import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

declare var jQuery: any;

@Component({
    selector: 'app-character',
    templateUrl: './character.component.html',
    styleUrls: ['./character.component.css']
})
export class CharacterComponent implements OnInit {
    title = 'test app';
    surveyMetaId: string;
    learningPathId: string;
    learningPathOrLearningTourId:string;
    learningTourId: string;
    surveyId: string;
    method: number

    constructor(private route: ActivatedRoute) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.surveyMetaId = params['surveyMetaId'];
            this.learningPathOrLearningTourId = params['learningPathOrLearningTourId'];
            this.method = params['method'];
            if(this.method==1){
                this.learningPathId = this.learningPathOrLearningTourId;
                this.learningTourId = 'not';
            }else if(this.method==2){
                this.learningTourId = this.learningPathOrLearningTourId;
                this.learningPathId = 'not';
            }
        });

        jQuery.getScript("/assets/js/echarts.min.js", function(data, status, jqxhr) {
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/character.component.ts